enum CancellationReasons {
  InvalidCardType = '6',
  TechnicalIssue = '15',
  SsnNotVerified = '22',
  SessionExpiredByUi = '49',
}

export default CancellationReasons;
